<template>
  <div id="app">
    <el-form
      :model="videoForm"
      :rules="rules"
      ref="videoForm"
      label-width="80px"
      class="demo-videoForm"
    >
      <el-form-item
        class="upload-video-wrapper"
        label="上传视频"
        prop="urlName"
      >
        <el-upload
          class="upload-video"
          name="fileInfo"
          drag
          :action="uploadVideoFileUrl"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :on-success="handleSuccess"
          :on-error="handleError"
          :on-change="uploadChange"
          :before-upload="beforeUpload"
          :file-list="fileList"
          accept=".mp3,.mp4,.wma,.wav,.avi,.wm,.wmp,.wmv,.rm,.rmvb,.mov,.flv,.mpeg,.mpg,.mpv2,.m4v,.mpeg4,.3gp,.3gp2,.3gpp,.vob,.amv,.mkv,.mxf,.vp6,.webm,.ogg,.ape,.flac,.aac,.asf"
        >
          <i class="upload-icon"></i>
          <div class="el-upload__text">
            点击选择或拖拽视频到这里
            <el-tooltip
              effect="dark"
              placement="right"
              popper-class="upload-info-text-wrapper"
              v-model="tooltipVisible"
            >
              <div slot="content" class="upload-info-text">
                支持的格式包括：<br />
                mp3、mp4、wma、wav、avi、wm、wmp、<br />
                wmv、rm、rmvb、mov、flv、mpeg、mpg、<br />
                mpv2、m4v、mpeg4、3gp、3gp2、<br />
                3gpp、vob、amv、mkv、mxf、vp6、 webm、ogg、<br />
                ape、flac、aac、asf
              </div>
              <i class="upload-info-icon"></i>
            </el-tooltip>
          </div>
          <!-- <div class="el-upload__tip" slot="tip">
            只能上传视频文件，且不超过1gb
          </div> -->
        </el-upload>
        <div class="attention-text">
          <i class="upload-attention-icon"></i
          >上传任何违法内容都将无法获得交稿并追究法律责任，本服务支持时长<span
            class="red"
            >2小时内</span
          >的， <span class="red">1GB</span>以下的常见音视频文件
        </div>
      </el-form-item>

      <el-form-item
        :inline-message="true"
        class="language-wrapper"
        label="选择语言"
        prop="desLang"
      >
        <el-select
          v-model="videoForm.srcLang"
          placeholder="视频源语言"
          class="src-lang"
          @change="srcLangOnChange"
          ref="srcLang"
        >
          <el-option
            v-for="item in srcOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <i class="language-arrow"></i>
        <el-select
          v-model="videoForm.desLang"
          placeholder="目标语言"
          class="des-lang"
          @change="desLangOnChange"
        >
          <el-option
            v-for="item in desOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <div class="language-text">
          视频源语言与目标语言相同时，只转写为文本，不翻译。其他语种请选择
          <a :href="humanTranslateUrl" class="blue">人工视频翻译</a>。
        </div>
      </el-form-item>
      <el-form-item
        class="format-wrapper"
        :inline-message="true"
        label="交稿格式"
        prop="resultType"
      >
        <el-select
          v-model="videoForm.resultType"
          placeholder="请选择"
          class="resultType-input"
          @change="resultTypeOnChange"
        >
          <el-option
            v-for="item in resultTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <div @click="showExample" class="show-example">查看示例</div>
      </el-form-item>
      <el-form-item
        class="phoneInfo-wrapper"
        :inline-message="true"
        label="联系电话"
        prop="phoneInfo"
      >
        <el-input
          class="phoneInfo-input"
          placeholder="请输入"
          v-model="videoForm.phoneInfo"
        ></el-input>
        <div class="phoneInfo-text">订单状态将通过短信方式同步给您</div>
      </el-form-item>
      <el-form-item
        class="emailInfo-wrapper"
        :inline-message="true"
        label="邮箱"
        prop="emailInfo"
      >
        <el-input
          class="emailInfo-input"
          placeholder="请输入"
          v-model="videoForm.emailInfo"
        ></el-input>
        <div class="emailInfo-text">字幕文件将通过邮件发送给您</div>
      </el-form-item>
      <el-form-item class="orderInfo-panel" label="订单信息">
        <div class="orderInfo-line">
          <span class="label">视频时长</span>
          <span class="number1">{{ orderInfo.videoDuration }}</span>
          <span class="line"></span>
          <span class="label">预计价格</span>
          <span class="number2">{{ orderInfo.orderPrice }}</span>
          <span class="line"></span>
          <span class="label">翻译时长</span>
          <span class="number3">{{ orderInfo.translateDuration }}</span>
        </div>
        <div class="orderInfo-notice">
          收费标准：0.3元/分钟（不足一分钟按一分钟计算），
          <a :href="vipUrl" class="red">VIP用户0.2元/分钟。 开通VIP>></a>
        </div>
      </el-form-item>
      <el-form-item :inline-message="true" class="clause-panel" prop="checked">
        <el-checkbox v-model="videoForm.checked"
          >我已阅读并同意《有道人工翻译服务条款》</el-checkbox
        >
      </el-form-item>
      <el-form-item class="submit-panel">
        <div
          class="submit-button"
          type="primary"
          @click="submitForm('videoForm')"
        >
          提交翻译
        </div>
        <a v-if="!isVipUser" class="vip-notice" :href="vipUrl">
          <i class="vip-notice-icon"></i> 开通个人vip, 立享ai视频翻译7折优惠,
          让翻译更省钱!
        </a>
        <!-- <el-button @click="resetForm('videoForm')">重置</el-button> -->
      </el-form-item>
    </el-form>
    <el-dialog title="交稿示例" :visible.sync="dialogVisible">
      <el-tabs v-model="dialogActiveName" @tab-click="changeDialogTab">
        <el-tab-pane label="SRT字幕文件" name="srt">
          <div>
            <div class="srt-title">
              SRT字幕文件包含时间轴和由AI转写、翻译的文本内容。可以拖入常用播放器中与视频一起播<br />
              放，可以使用Windows下的“记事本”或Mac下的“文本编辑”查看和编辑。大致形式如下:
            </div>
            <div class="srt-content">
              1<br />
              00:00:01,100 --> 00:00:03,100<br />
              我们聘请全球多个国家的本地化译员，<br />
              <!-- 我们在世界许多国家聘请当地翻译，<br /> -->
              <br />
              2 <br />
              00:00:03,100 --> 00:00:07,200<br />
              译员在各自擅长的领域里都有丰富的翻译经验。<br />
              <!-- 译员在各自专业领域拥有丰富的翻译经验。<br /> -->
              <br />
              3 <br />
              00:00:07,200 --> 00:00:11,300<br />
              确保每位译员都能提供高品质的翻译。<br />
              <!-- 确保每位译者都能提供高质量的翻译。 -->
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="TXT纯文本文件" name="txt">
          <div class="des-title">
            TXT纯文本文件不包含时间轴信息，仅包含由AI转写的文本。可以使用Windows下的“记事本”<br />
            或Mac下的“文本编辑”查看和编辑。大致形式如下:
          </div>
          <div class="des-content">
            我们在世界许多国家聘请当地翻译，<br />
            译员在各自专业领域拥有丰富的翻译经验。<br />
            确保每位译者都能提供高质量的翻译。
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import apiConfig from "@/config";

const desLangMap = {
  zh: [
    {
      value: "zh",
      label: "中文",
    },
    {
      value: "en",
      label: "英文",
    },
    {
      value: "jp",
      label: "日文",
    },
    {
      value: "kr",
      label: "韩文",
    },
  ],
  en: [
    {
      value: "zh",
      label: "中文",
    },
    {
      value: "en",
      label: "英文",
    },
  ],
  jp: [
    {
      value: "zh",
      label: "中文",
    },
    {
      value: "jp",
      label: "日文",
    },
  ],
  kr: [
    {
      value: "zh",
      label: "中文",
    },
    {
      value: "kr",
      label: "韩文",
    },
  ],
};
const baseUrl = apiConfig.baseUrl;
const getVideoEstimateInfoUrl =
  baseUrl + "/aiTranslate.do?method=getVideoEstimateInfo";
const checkisVipUserUrl = baseUrl + "/user.do?method=isVipUser";
const submitAIVideoTransOrderUrl =
  baseUrl + "/aiTranslate.do?method=submitAIVideoTransOrder";
const vipUrl = baseUrl + "/?path=vip&keyfrom=Nav-vip";
const humanTranslateUrl = baseUrl + "/?path=localTransSubmit&contentType=video";
const uploadVideoFileUrl = baseUrl + "/aiTranslate.do?method=uploadVideoFile";
const getUserInfoUrl = baseUrl + "/user.do?method=getUserInfo";
export default Vue.extend({
  name: "App",
  data() {
    return {
      vipUrl: vipUrl,
      humanTranslateUrl: humanTranslateUrl,
      uploadVideoFileUrl: uploadVideoFileUrl,
      tooltipVisible: false,
      isVipUser: false,
      dialogVisible: false,
      dialogActiveName: "srt",
      srcOptions: [
        {
          value: "zh",
          label: "中文",
        },
        {
          value: "en",
          label: "英文",
        },
        {
          value: "jp",
          label: "日文",
        },
        {
          value: "kr",
          label: "韩文",
        },
      ],
      desOptions: [
        {
          value: "zh",
          label: "中文",
        },
        {
          value: "en",
          label: "英文",
        },
      ],
      resultTypeOptions: [
        {
          value: "SRT",
          label: "SRT字幕文件",
        },
        {
          value: "TXT",
          label: "纯文本文件",
        },
      ],
      value: "",
      fileList: [],
      // fileList: [{ name: "12312" }],
      videoForm: {
        srcLang: "",
        desLang: "",
        phoneInfo: "",
        emailInfo: "",
        resultType: "",
        orderPrice: "",
        urlName: "",
        checked: true,
      },
      orderInfo: {
        translateDuration: "-",
        orderPrice: "-",
        videoDuration: "-",
      },
      rules: {
        urlName: [{ required: true, message: "请上传文件", trigger: "change" }],
        resultType: [
          { required: true, message: "请选择交稿格式", trigger: "change" },
        ],
        phoneInfo: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            pattern: /^1[0-9]{10}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        emailInfo: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱格式", trigger: "blur" },
        ],
        checked: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请勾选同意"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        desLang: [
          {
            validator: (rule, value, callback) => {
              let srcLang = this.$refs.srcLang.value;
              console.log(srcLang);
              if (!value || !srcLang) {
                callback(new Error("请选择语言"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
          { required: true, message: "请选择语言", trigger: "blur" },
        ],
        date1: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        date2: [
          {
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
        type: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个活动性质",
            trigger: "change",
          },
        ],
        resource: [
          { required: true, message: "请选择活动资源", trigger: "change" },
        ],
        desc: [{ required: true, message: "请填写活动形式", trigger: "blur" }],
      },
    };
  },

  created() {
    this.checkisVipUser();
    this.getUserInfo();
  },
  methods: {
    checkisVipUser() {
      axios.get(checkisVipUserUrl).then((res) => {
        // console.log(res);
        this.isVipUser = res.data.vip;
      });
    },
    getUserInfo() {
      axios.get(getUserInfoUrl).then((res) => {
        console.log(res);
        if (res.status !== 200) return;
        if (res.data.status == "1") {
          this.videoForm.phoneInfo = res.data.phone;
          this.videoForm.emailInfo = res.data.email;
        }
      });
    },
    srcLangOnChange(val, oldVal) {
      if (val !== oldVal) {
        this.desOptions = desLangMap[val];
        this.videoForm.desLang = "";
      }
    },
    desLangOnChange(val) {
      console.log(val);
    },
    resultTypeOnChange(val) {
      console.log(val);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.videoForm.urlName = "";
      this.initVideoEstimateInfo();
      this.$refs.videoForm.validateField("urlName");
    },
    uploadChange(file, fileList) {
      // 验证文件数量，替换后仅保留第一个文件
      if (fileList.length > 1) {
        fileList.splice(0, 1);
        this.videoForm.urlName = "";
        this.initVideoEstimateInfo();
        this.$refs.videoForm.validateField("urlName");
      }
    },
    handlePreview(file) {
      console.log(file);
    },
    beforeUpload(file) {
      const isLt1G = file.size / 1024 / 1024 / 1024 < 1; // 限制文件大小为 1GB
      const reg =
        /\.(mp3|mp4|wma|wav|avi|wm|wmp|wmv|rm|rmvb|mov|flv|mpeg|mpg|mpv2|m4v|mpeg4|3gp|3gp2|3gpp|vob|amv|mkv|mxf|vp6|webm|ogg|ape|flac|aac|asf)$/i; // 支持的格式正则表达式
      const isFormatValid = reg.test(file.name) || reg.test(file.type); // 判断文件格式是否满足要求
      if (!isLt1G) {
        this.$message.error("上传文件大小不能超过 1GB!");
      } else if (!isFormatValid) {
        this.$message.error("上传文件格式不支持!");
      }
      return isLt1G && isFormatValid; // 返回 true 表示上传文件，返回 false 则取消上传
    },
    handleSuccess(response, file, fileList) {
      console.log(response, file, fileList);
      console.log(response.urlName);
      this.videoForm.urlName = response.urlName;
      this.getVideoEstimateInfo();
      // this.$refs["videoForm"].clearValidate();
      this.$refs.videoForm.validateField("urlName");
    },
    handleError(err, file, fileList) {
      console.log(err, file, fileList);
      this.$refs.videoForm.validateField("urlName");
    },
    initVideoEstimateInfo() {
      this.videoForm.orderPrice = "";
      this.orderInfo.orderPrice = "-";
      this.orderInfo.videoDuration = "-";
      this.orderInfo.translateDuration = "-";
    },
    getVideoEstimateInfo() {
      axios
        .post(getVideoEstimateInfoUrl, {
          urlName: this.videoForm.urlName,
        })
        .then((res) => {
          console.log(res);
          if (res.status !== 200 || !res.data) {
            return;
          }
          this.videoForm.orderPrice = res.data.orderPrice;
          this.orderInfo.orderPrice = res.data.orderPrice
            ? res.data.orderPrice + "元"
            : "";
          this.orderInfo.videoDuration = res.data.videoDuration;
          this.orderInfo.translateDuration = res.data.translateDuration;
        });
    },
    showExample() {
      this.dialogVisible = true;
    },
    changeDialogTab(tab, event) {
      console.log(tab, event);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert("submit!");
          console.log(this.videoForm);
          axios.post(submitAIVideoTransOrderUrl, this.videoForm).then((res) => {
            console.log(res);
            if (res.status === 200) {
              if (res.data && res.data.isLogin === false) {
                // $("a.login-ctrl").click();
                var loginCtrl = document.querySelector("a.login-ctrl");
                if (loginCtrl) {
                  loginCtrl.click();
                } else {
                  window.location.reload();
                  setTimeout(() => {
                    var loginCtrl = document.querySelector("a.login-ctrl");
                    if (loginCtrl) {
                      loginCtrl.click();
                    }
                  }, 3000);
                }
                return;
              }
              if (res.data && res.data.redirectUrl) {
                window.location.href = res.data.redirectUrl;
              }
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
});
</script>

<style lang="scss">
#app {
  width: 960px;
  height: 1060px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid #efefef;
  box-sizing: border-box;
  padding: 40px 48px 56px 48px;
}
.upload-video {
  width: 764px;
  height: 140px;
  position: relative;
}
.upload-video .el-upload-dragger {
  width: 764px;
  height: 140px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px dashed #e1e3e5;
  background: rgba(245, 245, 247, 0.5);
  &:active {
    border-color: #e1e3e5;
  }
  &:hover {
    border-color: #e1e3e5;
  }
  &:focus {
    border-color: #e1e3e5;
  }
  &:visited {
    border-color: #e1e3e5;
  }
}
.upload-video .el-upload__text {
  color: #a3a8ad;
  text-align: center;
  font-family: PingFang SC;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
}
.upload-video .upload-icon {
  display: inline-block;
  margin-top: 40px;
  width: 32px;
  height: 32px;
  background: url("~@/assets/images/upload-icon@2x.png");
  background-size: cover;
  line-height: 0;
}
.upload-video .upload-info-icon {
  display: inline-block;
  width: 12px;
  height: 12px;
  line-height: 20px;
  flex-shrink: 0;
  background: url("~@/assets/images/upload-info-icon@2x.png");
  background-size: cover;
  vertical-align: -1px;
}
.upload-video-wrapper {
  // margin-bottom: 40px;
  // position: relative;
  // padding-bottom: 30px;
  margin-bottom: 70px;
}
.upload-video-wrapper .upload-attention-icon {
  display: inline-block;
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  background: url("~@/assets/images/upload-attention-icon@2x.png");
  background-size: cover;
  line-height: 0;
  vertical-align: -1px;
  margin-right: 4px;
}
.language-wrapper {
  margin-top: 10px;
  margin-bottom: 70px;
}

.language-wrapper .src-lang {
  width: 120px;
}
.language-wrapper .des-lang {
  width: 120px;
}
.language-wrapper .language-arrow {
  display: inline-block;
  width: 14px;
  height: 11px;
  flex-shrink: 0;
  background: url("~@/assets/images/language-arrow-icon@2x.png");
  background-size: cover;
  margin: 0 12px;
}
.language-wrapper .language-text {
  color: #a3a8ad;
  font-family: PingFang SC;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
  margin-top: 12px;
  position: absolute;
}
.language-wrapper .blue {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: left;
  color: rgb(77, 113, 255);
  cursor: pointer;
  margin-top: 12px;
  text-decoration: none;
}
.format-wrapper {
  border-bottom: 1px dashed rgba(213, 213, 213, 1);
  padding-bottom: 70px;
}
.format-wrapper .show-example {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: left;
  color: rgba(77, 113, 255, 1);
  cursor: pointer;
  margin-top: 12px;
  position: absolute;
}
.upload-info-text-wrapper {
  width: 300px !important;
}
.upload-info-text {
  color: #fff;
  font-family: PingFang SC;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 15px */
}
.phoneInfo-wrapper {
  margin-top: 40px;
  margin-bottom: 70px;
}
.emailInfo-wrapper {
  margin-top: 40px;
  margin-bottom: 40px;
  border-bottom: 1px dashed rgba(213, 213, 213, 1);
  padding-bottom: 70px;
}

.phoneInfo-wrapper .phoneInfo-input {
  width: 278px;
}
.phoneInfo-wrapper .phoneInfo-text {
  color: #a3a8ad;
  font-family: PingFang SC;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
  margin-top: 12px;
  position: absolute;
}
.emailInfo-wrapper .emailInfo-input {
  width: 278px;
}
.emailInfo-wrapper .emailInfo-text {
  color: #a3a8ad;
  font-family: PingFang SC;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
  margin-top: 12px;
  position: absolute;
}
.orderInfo-panel {
  margin-bottom: 56px;
}
.orderInfo-line {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 12px;
  margin-top: 10px;
}
.orderInfo-line .label {
  margin-right: 8px;
  color: #999;
  font-family: PingFang SC;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.orderInfo-line .number1 {
  color: #2b333d;
  font-family: PingFang SC;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px; /* 77.778% */
  min-width: 39px;
  // margin-right: 8px;
}
.orderInfo-line .number2 {
  color: #2b333d;
  font-family: PingFang SC;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px; /* 77.778% */
  min-width: 50px;
  // margin-right: 8px;
}
.orderInfo-line .number3 {
  color: #2b333d;
  font-family: PingFang SC;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px; /* 77.778% */
  // width: 72px;
  margin-right: 8px;
}
.orderInfo-line .line {
  width: 1px;
  height: 16px;
  flex-shrink: 0;
  background: #ddd;
  margin-right: 20px;
  margin-left: 20px;
}
.orderInfo-notice {
  color: #a3a8ad;
  font-family: PingFang SC;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
  .red {
    text-decoration: none;
    color: rgba(251, 74, 62, 1);
    background-color: #fff;
  }
}

.el-tooltip__popper.is-dark {
  height: 110px;
  width: 223.996px;
  flex-shrink: 0;
  fill: #000;
  opacity: 0.5;
  filter: drop-shadow(0px 0px 14px rgba(39, 72, 155, 0.08));
}
.attention-text {
  color: #a3a8ad;
  font-family: PingFang SC;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
  margin-top: 12px;
  // position: absolute;
  // top: 140px;
  // width: 100%;
  .red {
    text-decoration: none;
    color: rgba(251, 74, 62, 1);
  }
}
.resultType-input {
  width: 278px;
}
.clause-panel {
  margin-bottom: 10px;
}
.fileView .vip-notice {
  padding-top: 0px !important;
}
.vip-notice {
  color: rgba(251, 74, 62, 1) !important;
  background-color: #fff !important;
  font-family: PingFang SC;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px; /* 100% */
  margin-top: 16px;
  text-decoration: none;
  .vip-notice-icon {
    display: inline-block;
    width: 13.33px;
    height: 12px;
    flex-shrink: 0;
    background: url("~@/assets/images/notice-icon@2x.png");
    background-size: cover;
    vertical-align: -1px;
  }
}

.submit-button {
  width: 120px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 4px;
  background: #fb3a4d;
  color: #fff;
  font-family: PingFang SC;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 36px; /* 100% */
  text-align: center;
  cursor: pointer;
}
.el-upload-list {
  position: absolute;
  top: 160px;
  width: 100%;
}
.is-uploading {
  // margin-top: 24px !important;
}
.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner {
  border-color: #dcdfe6;
  box-shadow: none;
}
.el-select .el-input__inner:focus {
  border-color: #dcdfe6;
  box-shadow: none;
}
.el-input.is-active .el-input__inner,
.el-input__inner:focus {
  border-color: #dcdfe6;
  box-shadow: none;
}
.el-select-dropdown__item.selected {
  color: rgba(251, 74, 62, 1);
}
.el-icon-arrow-up:before {
  content: "";
  display: inline-block;
  width: 8px;
  height: 4px;
  vertical-align: middle;
  flex-shrink: 0;
  transform: rotate(180deg);
  background: url("~@/assets/images/language-select-icon@2x.png");
  background-size: cover;
}
.el-checkbox__label {
  color: rgba(99, 105, 112, 1);
  font-family: PingFang SC;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px; /* 100% */
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: rgba(99, 105, 112, 1);
  font-family: PingFang SC;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px; /* 100% */
}
.el-checkbox__inner::after {
  border: 1px solid #fd4b5c;
  border-left: 0;
  border-top: 0;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #fff;
  border-color: #fff;
  border: 1px solid #ccc;
}
.el-checkbox__inner:hover {
  border-color: #ccc;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #ccc;
}
.el-upload-list__item {
  background: transparent !important;
}
.el-upload-list__item.is-success .el-upload-list__item-name:focus,
.el-upload-list__item.is-success .el-upload-list__item-name:hover {
  background-color: #fff;
  color: #2b333d;
  font-family: PingFang SC;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  // background: #fff !important;
}
.el-upload-list__item-name {
  color: #2b333d;
  font-family: PingFang SC;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  background: #fff !important;
}
.el-progress-bar__inner {
  background-color: rgba(251, 74, 62, 1);
}
.el-upload-list__item:first-child {
  margin-top: 20px;
}
.el-dialog {
  width: 620px;
  height: 518px;
  background: #fafbfd;
  border-radius: 4px;
}
.el-dialog__header {
  padding-top: 24px;
  padding-left: 24px;
  padding-bottom: 0;
}
.el-dialog__title {
  color: #2a2b2e;
  font-family: PingFang SC;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding-top: 8px;
}
.el-dialog__headerbtn {
  top: 16px;
  right: 16px;
  background: url("~@/assets/images/dialog-delete-icon@2x.png");
  background-size: cover;
  width: 16px;
  height: 16px;
}
.el-dialog__headerbtn .el-dialog__close:before {
  content: "";
}
// .el-icon-close:before {
//   content: "";
// }
.el-dialog__body {
  padding: 24px;
}
.el-tabs__item {
  color: #2a2b2e;
  font-family: PingFang SC;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  height: 33px;
}
.el-tabs__item.is-active {
  color: #2a2b2e;
}
.el-tabs__active-bar {
  background-color: rgba(251, 74, 62, 1);
}
.el-tabs__item:hover {
  color: #2a2b2e;
}
.el-tabs__nav-wrap::after {
  background-color: rgba(230, 231, 232, 1);
}
.srt-title {
  color: rgba(147, 149, 153, 1);
  font-family: PingFang SC;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  margin-bottom: 16px;
}
.srt-content {
  width: 572px;
  height: 312px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid #e6e7e8;
  background: #fff;
  box-sizing: border-box;
  padding: 16px;
  color: #626469;
  font-family: PingFang SC;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
}
.des-title {
  width: 575px;
  color: rgba(147, 149, 153, 1);
  font-family: PingFang SC;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  margin-bottom: 16px;
}
.des-content {
  width: 572px;
  height: 312px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid #e6e7e8;
  background: #fff;
  box-sizing: border-box;
  padding: 16px;
  color: #626469;
  font-family: PingFang SC;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
}
.el-tabs__header {
  margin-bottom: 16px;
}
.el-upload-list__item-name {
}
.el-form-item.is-error .el-input__inner,
.el-form-item.is-error .el-input__inner:focus,
.el-message-box__input input.invalid,
.el-message-box__input input.invalid:focus {
  border-color: #dcdfe6;
  box-shadow: none;
  // border-color: #f56c6c;
}

@media not all and (min-resolution: 0.001dpcm) {
  @supports (-webkit-appearance: none) {
    .el-upload-list__item:first-child {
      margin-top: 40px;
    }
  }
}

@media not all and (min-resolution: 0.001dpcm) {
  @supports (-webkit-appearance: none) and (stroke-color: transparent) {
    /* Safari浏览器特有的CSS样式 */
    /* 在这里添加你想要应用于Safari浏览器的样式 */
    .el-upload-list__item:first-child {
      margin-top: 40px;
    }
  }
}
</style>
